import { FC } from 'react';
import Input from '../Input/Input';
import Stack from '../Stack/Stack';

export interface Vector3Value {
  x: number;
  y: number;
  z: number;
}

interface Vector3Props {
  value?: Vector3Value;
  onChange?: (value: Vector3Value) => void;
  step?: number;
  className?: string;
}

const Vector3: FC<Vector3Props> = ({ 
  value = { x: 0, y: 0, z: 0 }, 
  onChange,
  step = 0.1,
  className = ''
}) => {
  const handleChange = (axis: keyof Vector3Value, newValue: number) => {
    if (!onChange) return;
    
    onChange({
      ...value,
      [axis]: newValue
    });
  };

  return (
    <Stack direction="horizontal" gap="sm" className={`vector3 ${className}`}>
      <Input
        type="number"
        value={value.x}
        onChange={(val) => handleChange('x', typeof val === 'number' ? val : 0)}
        step={step}
        suffix="X"
      />
      <Input
        type="number"
        value={value.y}
        onChange={(val) => handleChange('y', typeof val === 'number' ? val : 0)}
        step={step}
        suffix="Y"
      />
      <Input
        type="number"
        value={value.z}
        onChange={(val) => handleChange('z', typeof val === 'number' ? val : 0)}
        step={step}
        suffix="Z"
      />
    </Stack>
  );
};

export default Vector3; 